import { GenericOverlay } from './generic-overlay'
import styles from 'css/components/generic-overlay.module.css'

export const LaunchLessonOverlay = ({lessonId, lessonName, className, onDismiss, onLaunch, buttonTextA, buttonTextB}) => {
    const message = (
        <>You are about to launch lesson “{lessonName}” to present to your class {className}.</>
    )

    const body = (
        <>
        {message}
        <div className={`${styles.actionRow} ${styles.endRow}`}>
            <div className={styles.actionButton} onClick={onDismiss}>
              {buttonTextA || 'Cancel'}
            </div>
            <div className={styles.actionButton} onClick={onLaunch}>
              {buttonTextB || 'Open'}
            </div>
          </div>
        </>
    )

    return (
        <GenericOverlay
            body={body}
        />
    )
}
